import { LOCALE_TYPE } from 'locales/locale';
import { LocaleType } from 'types/constants/locale';
import {
  GadgetModel, LayoutEditResponse, LayoutEntry, LayoutResponse, MainMenuItemEditModel,
} from 'types/entity';
import { gadgetEditToGadget } from './gadget';

export const layoutEditToLayout = (
  entity: LayoutEditResponse,
  locale: LocaleType,
): LayoutResponse => ({
  layout_id: entity.layout_id,
  layout_name: locale === LOCALE_TYPE.EN ? entity.layout_name_en : entity.layout_name_ja,
  roles: entity.roles,
  gadget: entity.gadget
    ? entity.gadget
      .map((value) => gadgetEditToGadget(value, locale))
      .filter(Boolean) as GadgetModel[]
    : [],
});

export const layoutEditToEntry = (
  entity: LayoutEditResponse,
  mainMenuMap: { [main_menu_id: string]: MainMenuItemEditModel[] },
): LayoutEntry => ({
  roles: entity.roles,
  gadgets: !entity.gadget
    ? []
    : entity.gadget.map((g) => ({
      gadget: g,
      main_menu_items: mainMenuMap[g.gadget_contents_id || ''] || [],
    })),
});
